"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.coreInitiativesSummaryGetAsyncSlice = void 0;
exports.refreshCurrentInitiativeSummarySaga = refreshCurrentInitiativeSummarySaga;
const xuder_1 = require("@sonar-software/xuder");
const _api_1 = require("../../../api/index.js");
const effects_1 = require("redux-saga/effects");
const selectors_1 = require("../selectors.js");
const actions_1 = require("../_idMap/actions.js");
exports.coreInitiativesSummaryGetAsyncSlice = (0, xuder_1.createGetAsyncSlice)({
    httpSagaOptions: {
        successCombinationActionCreators: [
            (request, response) => (0, actions_1.updateInitiativeReferences)([
                {
                    initiativeId: request.initiativeId,
                    ownerIds: response.ownerIds,
                    scopeCounts: response.scopeCounts,
                    stakeholders: response.stakeholders
                }
            ])
        ]
    },
    name: 'CoreInitiativesSummary',
    receive: true,
    request: true,
    requestHandler: _api_1.getInitiativeSummary
});
function* refreshCurrentInitiativeSummarySaga() {
    const initiativeId = yield (0, selectors_1.selectCurrentInitiativeId)();
    if (initiativeId) {
        yield (0, effects_1.put)(exports.coreInitiativesSummaryGetAsyncSlice.asyncActionCreators.requestGetCoreInitiativesSummary({
            initiativeId
        }));
    }
}
//# sourceMappingURL=get.js.map